export default "/images/m1-web.jpg";